import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class ProductEstimatedDelivery extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateDelivery);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateDelivery);
  }

  /**
   * Updates the estimated delivery indicator after a variant change.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateDelivery = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newDelivery = event.detail.data.html.querySelector('product-estimated-delivery');

    if (!newDelivery) return;

    morph(this, newDelivery, { childrenOnly: true });
  };
}

if (!customElements.get('product-estimated-delivery')) {
  customElements.define('product-estimated-delivery', ProductEstimatedDelivery);
}
